import { isCapacitorNative } from "@/lib/capacitor"

export const MOBILE_OAUTH_SCHEME = "com.sigmai.app"
export const OAUTH_RETURN_EVENT = "sigmai:oauth-return"

export type OAuthReturnDetail = {
  provider: string
  playerId: string | null
  error: boolean
  next: string | null
}

export function isSafeAppPath(path: string | null | undefined): path is string {
  if (!path) return false
  return path.startsWith("/") && !path.startsWith("//") && !path.includes("://")
}

export function currentAppReturnPath(): string {
  if (typeof window === "undefined") return "/"
  return `${window.location.pathname}${window.location.search}`
}

export function parseAppOAuthUrl(url: string): OAuthReturnDetail | null {
  let parsed: URL
  try {
    parsed = new URL(url)
  } catch {
    return null
  }

  const route = `${parsed.hostname || ""}${parsed.pathname || ""}`.replace(/\/+$/, "")
  const match = route.match(/oauth\/(instagram|whoop)$/)
  if (!match) return null

  const next = parsed.searchParams.get("next")
  return {
    provider: match[1],
    playerId: parsed.searchParams.get("id"),
    error: parsed.searchParams.get("error") === "1",
    next: isSafeAppPath(next) ? next : null,
  }
}

export function dispatchOAuthReturn(detail: OAuthReturnDetail) {
  if (typeof window === "undefined") return
  window.dispatchEvent(new CustomEvent<OAuthReturnDetail>(OAUTH_RETURN_EVENT, { detail }))
}

export async function openExternalAuth(url: string): Promise<void> {
  if (isCapacitorNative()) {
    const { Browser } = await import("@capacitor/browser")
    await Browser.open({
      url,
      presentationStyle: "fullscreen",
    })
    return
  }
  window.open(url, "_blank", "noopener,noreferrer")
}

export async function closeExternalAuth(): Promise<void> {
  if (!isCapacitorNative()) return
  try {
    const { Browser } = await import("@capacitor/browser")
    await Browser.close()
  } catch {
    // Already closed or platform does not support close()
  }
}
